/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce( func, wait, immediate ) {
	var timeout;
	if ( ! wait ) { console.warn( "Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective." ); }
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if ( ! immediate ) { func.apply( context, args ); }
		};

		var callNow = immediate && !timeout;
		clearTimeout( timeout );
		timeout = setTimeout( later, wait );
		if ( callNow ) { func.apply( context, args ); }
	};
};



/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */


/**
 * A cross-browser compatible event creator function.
 */
function create_event( event_name ) {
	if ( typeof( Event ) === 'function' ) {
		var event = new Event( event_name );
	} else {
		var event = document.createEvent( 'Event' );
		event.initEvent( event_name, true, true );
	}
	return event;
}

var debounceScroll =  create_event( 'debounceScroll' );

jQuery( window ).on( 'load', function() {
	var delay_time = 50;
	var delay_start = 0;
	var last_scroll_pos = 0;
	// The one scroll event handler to rule them all.
	jQuery( window ).scroll( function( event ) {
		// If we are already scrolling, reset the delay
		if ( delay_start ) { clearTimeout( delay_start ); }

		// Are we scrolling down?
		var scrollDown = $( window ).scrollTop() > last_scroll_pos;
		last_scroll_pos = $( window ).scrollTop(); // Save for next time

		delay_start = setTimeout( function( event ) {
			debounceScroll.scrollDown = scrollDown;
			window.dispatchEvent( debounceScroll );
		}, delay_time );
	});
});


/**
 * Counter - animates number counting.
 *
 * 	- Takes an element that must have a class of 'counter-js'.
 * 	- Counting doesn't begin until the element is scrolled into view.
 * 	- Digits of the number are wrapped in a span for styling purposes
 * 	  and commas are added every three characters after the decimal.
 *
 *
 * @usage:
 *
 * 		Create an element that has a class of 'counter-js' and add a
 * 		data attribute of end to be used as the number to count to.
 *
 * 		Other data attributes can be used to control various aspects
 * 		of the animation.
 *
 * 		data attributes:
 *
 * @data end - the number to count to.
 * @data start - the number to begin the count with. Defaults to 0.
 * @data decimal_places - the number of decimal places to use in the
 * 			count. Defaults to 0.
 * @data time - the length of time in milliseconds to complete the
 * 			count. Defaults to 3 seconds.
 * @data easing - the easing function to use in the animation.
 * 			Defaults to 'swing'.
 *
 * @example:
 *
 *  	<span class="counter-js" data-start="1.0" data-end="1234.5" data-time="3500" data-decimal_places="1" data-easing="easeInBack">
 *  		<span class="digit">1</span>
 *  		<span class="digit punctuation">,</span>
 *  		<span class="digit">2</span>
 *  		<span class="digit">3</span>
 *  		<span class="digit">4</span>
 *  		<span class="digit punctuation">.</span>
 *  		<span class="digit">5</span>
 *  	</span>
 *
 *
 * DBS>Interactive
 * @author Harold Bradley III
 */



/**
 * Counter object
 *
 * @param element - the DOM element that will contain the counter numbers
 *
 * @return Counter - an instance of the object
 */

 // Replacement for jquery .includes()
function includes(container, value) {
	var returnValue = false;
	var pos = container.indexOf(value);
	if (pos >= 0) {
		returnValue = true;
	}
	return returnValue;
}

function Counter( element ) {

	// Create a closure to refer to this in event handlers
	var counter = this;

	this.element = element;
	this.$element = jQuery( element );

	if ( ! this.$element.data( 'end' ) ) {
		console.warn( '[Counter]: Cannot proceed without data attribute end on element: ', this.element );
	}

	this.start = this.$element.data( 'start' ) === undefined ? 0 : this.$element.data( 'start' );
	this.end = this.$element.data( 'end' );
	this.decimal_places = this.$element.data( 'decimal_places' ) === undefined ? 0 : this.$element.data( 'decimal_places' );
	this.time = this.$element.data( 'time' ) === undefined ? 3000 : this.$element.data( 'time' );

	// Are we currently counting?
	this.counting = false;

	var element = jQuery( this );
	this.top = this.$element.offset().top;
	this.bottom = this.$element.offset().top + this.$element.height();
	this.window_height = $( window ).height();

	this.margin_top = 200;
	this.margin_bottom = this.window_height / 5;

	/**
	 * Function to test whether an element is in viewport or not
	 *
	 * @return boolean - true if element is in viewport
	 */
	function in_viewport() {
		var viewport_top = $( window ).scrollTop() + counter.margin_top;
		var viewport_bottom = counter.window_height + $( window ).scrollTop() - counter.margin_bottom;
		if ( viewport_top < counter.top && counter.top < viewport_bottom ) { return true; }
		return false;
	}

	// Reset element's top and bottom and window height at every resize.
	jQuery( window ).resize( function() {
		counter.top = counter.$element.offset().top;
		counter.bottom = counter.top + ( counter.$element.height() );
		counter.window_height = $( window ).height();
	});


	/**
	 * Begins the counting animation. This is where the magic happens.
	 */
	this.begin = function() {
		counter.counting = true;
		counter.$element
			.prop( 'number', counter.start )
			.animate( { number: counter.end, },
				{
					duration: counter.time,
					step: function ( number ) { counter.update_count( number ); }
				}
			);
	};


	/**
	 * Formats the counter number and casts to a string
	 *
	 * @param number - an integer to format
	 */
	this.format = function( number ) {
		return number.toFixed( this.decimal_places ).toString();
	};

	// Reset counter with start number on init
	this.show_number( this.format( this.start ), this.element );


	/**
	 * Displays the current count with number
	 *
	 * @param number - the integer to update
	 */
	this.update_count = function( number ) {
		this.show_number( this.format( number ), this.element );
	};



	/**
	 * Scrolling Methods
	 * To wait until element is visible before beginning the count.
	 */

	/**
	 * If it's already in view, begin counting now.
	 */
	if ( in_viewport() ) {
		this.begin();
		return this;
	}

	// Otherwise set up the scroll handler...

	/**
	 * Scroll event handler - runs the begin_count function when
	 * element is scrolled into view.
	 */
  	window.addEventListener( 'debounceScroll', function() {

		// Don't do anything if already counting
		if ( counter.counting ) { return; }

		// Begin counting when scrolled into view
		if ( in_viewport() ) {
			counter.begin();
		}
	}, false );

	return this;
}


/**
 * A method that loops through the digits of a number to format the
 * number in order to display it on the display_element.
 *
 * @param number (string) - the MUST be a string representing the
 * 			number to display
 * @param display_element - the element used to hold the number
 */
Counter.prototype.show_number = function ( number, display_element ) {

	// The number to display formatted as a string
	var number = number;

	// The element on which to display the number.
	var element = display_element;


	// Empty the current contents
	jQuery( element ).empty();


	// Pointers to the current and previous digits.
	var current_digit = null;
	var previous_digit = null;

	// Boolean that keeps track of when the number is part of
	// the decimal. Used to determine when to start tracking
	// for commas.
	var in_decimal = includes( number, '.' );

	// Integer to keep track of where to place commas
	var digit_counter = -1;  // Will be incremented to 0 for first character


	/**
	 * Function that determines whether or not a comma is necessary before a
	 * particular digit. Used when looping through the digits of a number.
	 *
	 * @param digit - single character representing the digit to test
	 *
	 * @return bool - returns true if the character needs a comma before it.
	 */
	var needs_comma_before = function( digit ) {
		if ( in_decimal ) { return false; }

		if ( digit === '.' ) {
			in_decimal = false;  // no longer in decimal
			return false;
		}

		// Don't need a comma just yet...
		if ( digit_counter < 2 ) { digit_counter++; return false; }

		// Now we need a comma:
		digit_counter = 0;  // Reset counter
		return true;
	};


	/**
	 * Function to insert a comma digit.
	 *
	 * Relies on closure context to set current_digit and previous_digit.
	 */
	function add_comma() {
		previous_digit = current_digit;  // Save current digit as previous digit
		current_digit = create_digit( ',' );  // Create new comma digit
		element.insertBefore( current_digit, previous_digit );  // Insert it before previous digit
	};


	/**
	 * create_digit - Sets up the elements and classes necessary for a digit
	 * or punctuation.
	 *
	 * @param digit - single character to add
	 *
	 * @return container - an html container that contains the digit
	 */
	function create_digit(digit) {
		var container = document.createElement( 'span' );
		var contents = document.createTextNode( digit );

		container.className = 'digit';
		if ( digit === '.' || digit === ',' ) { container.className = 'digit punctuation'; }

		// Add contents to container
		container.appendChild( contents );

		return container;
	};

	// Display Loop
	// Loop *backwards* through digits adding them to the display element
	// and adding commas where appropritate.
	for ( var i = number.length - 1; i > -1; i-- ) {
		if ( needs_comma_before( number[i] ) ) { add_comma(); }
		previous_digit = current_digit;  // Save current digit as previous digit
		current_digit = create_digit( number[i] );  // Create new current digit
		element.insertBefore( current_digit, previous_digit );  // Insert it before previous digit
	}
}

// Page load events
jQuery( window ).on( 'load', function() {
	jQuery( '.counter-js' ).each( function () {
		var counter = new Counter( this );
	});
	
	// Header w/State Outline
	$('#ky-outline .ky-draw').animate({'strokeDashoffset': 1400}, 5000);
	$('#ky-outline').addClass('animate');

	// Button to display sources section
 	$('#sources-toggle').click(function() {
		$('#sources-wrapper, .footer-nav').toggleClass('open');
		$(this).hide();
	});
});

// ==== Reveal Section Animations on Scroll ====
window.addEventListener( 'debounceScroll', function() {
	var	scrollTop = $(window).scrollTop();
	// Value to determine when animation triggers
	var top_space = 800;

	// Different trigger for mobile
	if ( $(window).innerWidth() < 769 ) {top_space = 600;}
	
	$('.layout').each(function(){
		var distanceFromTop = $(this).offset().top;

		$(this).outerHeight();

		if ( (scrollTop + top_space) > distanceFromTop ) {
			var liveSection = $(this).attr('data-section');
			$('.site-content').attr('data-section', liveSection);
		}
	});

	// Horse Sales
	if ($('.site-content').attr('data-section') === 'gavel') {

		if ( !$('#gavel').hasClass('animate') ) {
			$('#gavel-arm').addClass('animate');
			// This section title is different from the rest due to overflow styling
			$('.page-header .section-title').addClass('animate');
		}
	}

	if ($('.site-content').attr('data-section') === 'horse-value') {

		if ( !$('#sales-horses').hasClass('animate') ) {
			$('#sales-horses').addClass('animate');
		}
	}

	// Thoroughbred Impact
	if ($('.site-content').attr('data-section') === 'thoroughbred-impact') {

		if ( !$('#thoroughbred-impact').hasClass('animate') ) {
			$('#thoroughbred-impact, #thoroughbred-impact .section-title').addClass('animate');
		}
	}

	// Horses By Numbers
	if ($('.site-content').attr('data-section') === 'horses-by-numbers') {

		if ( !$('#horse-head').hasClass('animate') ) {
			$('#horse-head').addClass('animate');
			$('#people').addClass('animate');
			$('#horses-by-numbers .section-title').addClass('animate');
		}
	}

	// Put To Work
	if ($('.site-content').attr('data-section') === 'work') {

		if ( !$('#horse-jockey').hasClass('animate') ) {
			$('#horse-jockey').addClass('animate');
			$('.jobs').addClass('animate');
		}
	}

	// Recreation Impact
	if ($('.site-content').attr('data-section') === 'recreation') {

		if ( !$('#recreation-impact').hasClass('animate') ) {
			$('#recreation-impact .collide-in').addClass('animate');
			$('#recreation-impact .section-title').addClass('animate');
		}
	}

	// Gold Three column Layout (Recreation Impact)
	if ($('.site-content').attr('data-section') === 'gold-columns') {

		if ( !$('.three-column.gold').hasClass('animate') ) {
			$('.three-column.gold').addClass('animate');
		}
	}

	// Competition Impact
	if ($('.site-content').attr('data-section') === 'competition') {

		if ( !$('#competition-impact').hasClass('animate') ) {
			$('#competition-impact .collide-in').addClass('animate');
			$('#competition-impact .section-title').addClass('animate');
		}
	}

	// Blue Three column Layout (Competition Impact)
	if ($('.site-content').attr('data-section') === 'blue-columns') {

		if ( !$('.three-column.blue').hasClass('animate') ) {
			$('.three-column.blue').addClass('animate');
		}
	}

	// Racing Impact
	if ($('.site-content').attr('data-section') === 'racing') {

		if ( !$('#racing').hasClass('animate') ) {
			$('#racing').addClass('animate');
			$('#racing-impact .section-title').addClass('animate');
		}
	}

	// Purse Value
	if ($('.site-content').attr('data-section') === 'purse-value') {

		if ( !$('#purse-value .swipe-reveal').hasClass('animate') ) {
			$('#purse-value .swipe-reveal').addClass('animate');
		}
	}

	// Kentucky-Bred
	if ($('.site-content').attr('data-section') === 'ky-bred') {

		if ( !$('#grid').hasClass('animate') ) {
			$('#grid').addClass('animate');
		}
	}

	// Footer State Outline
	if ($('.site-content').attr('data-section') === 'footer-numbers') {

		if ( !$('#footer-numbers').hasClass('animate') ) {
			$('#ky-outline-footer .ky-draw-footer').animate({'strokeDashoffset': 1400}, 5000);
			$('#ky-outline-footer').addClass('animate');
		}
	}

	// Sources
	if ($('.site-content').attr('data-section') === 'sources') {

		if ( !$('#sources .section-title').hasClass('animate') ) {
			$('#sources .section-title').addClass('animate');
		}
	}
});